import {
  ClassScoreCard,
  IStyles,
  IconWrapper,
  NoContentCard,
  SecondaryButton,
  StudentSubjectPopup,
  deserify,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
  useFeatureEnabled,
} from '@geneo2-web/shared-ui';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Button, Grid, Typography, useMediaQuery } from '@mui/material';
import { SubjectPerformanceOverAllStats } from '@protos/analysis_management/analysis.student.apis_pb';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../../app/Context/GlobalContextProvider';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import {
  HOME,
  PERFORMANCE_STUDENT_CHAPTERWISE,
} from '../../../routeHandling/RoutesNomenclature';
import { getSubjectsMap } from '../../../utils/icons';
import {
  setOverallAnalysis,
  setPerformanceId,
  setPerformanceSubjectId,
} from '../reducer/performance.slice';
import { SuggestedLearning } from './components/SuggestedLearning';
import { Shimmer } from './shimmer';

import { v4 as uuidv4 } from 'uuid';
import { interactionEvent } from '../../Auth/Login/login_logout.events';
import {
  aiPerformanceCloseEvent,
  aiPerformanceOpenEvent,
} from '../utils_performance/performance.events';
import { useDownloadContext } from '../../../app/Context/DownloadContextProviderV2';
import { ResourceInfo } from '@protos/content_management/content.common.apis_pb';
import { RecommendationReqSendFromTypeEnum } from '@protos/geneo_ai/ai.student.recommendation.apis_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { Feature } from '@protos/school_management/school.db_pb';
import { ResourceLock } from '@protos/learning_management/lms.common.apis_pb';
import { currentSessionMode } from 'apps/student/src/utils/commonUtils';
import { useFilteredLearnSubjects } from '../../../utils/ssoUserHooks';

const styles: IStyles = {
  root: {
    width: { xs: '100vw', md: '100%' },
    // backgroundColor: 'red',
    // overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: { xs: pxToRem(0), md: pxToRem(20), lg: pxTovW(241) },
    paddingRight: { xs: pxToRem(0), md: pxToRem(20), lg: pxTovW(241) },
    paddingTop: { xs: pxToRem(20), md: pxTovW(40) },
    paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    boxSizing: 'border-box',
    // overflowX: 'hidden',
    justifyContent: 'center',
    // alignItems: 'center',
  },
  header: {
    width: '100%',
    display: 'flex',
    // flexDirection: 'column',
    paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    gap: { xs: pxToRem(10), md: pxTovW(22) },
    //
    marginLeft: { xs: pxToRem(20), md: pxTovW(0) },
    alignItems: 'center',
    // backgroundColor: 'red',
  },
  iconCard: {
    width: { xs: '90vw', md: '100%', lg: pxTovW(554) },
    height: { xs: pxToRem(81), md: pxTovW(121) },
    borderRadius: pxToRem(10),
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0DFDE',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pxToRem(10),
    boxSizing: 'border-box',
    boxShadow: `0px 0px ${pxToRem(10)} #0000001F`,
    marginLeft: { xs: pxToRem(0), md: pxTovW(0) },
  },
  dropDownButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '17px 20px 16px 20px',
    border: '1px solid #0AA34FAB',
    width: { xs: pxToRem(552), md: '100%', lg: pxTovW(552) },
    height: pxTovW(56),
    borderRadius: pxTovW(15),
    // marginTop: pxTovW(18),
    // marginBottom: pxTovW(20),
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(4), md: pxTovW(8) },
    flexDirection: 'column',
  },
  iconInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
  },
  chapterScoreCard: {
    minHeight: { md: pxTovW(100) },
    minWidth: { md: pxTovW(100) },
    width: { xs: '100vw', md: '100%', lg: pxTovW(794) },
    backgroundColor: 'common.white',
    // margin: { xs: 'auto', md: 'none' },
    gap: pxToRem(10),
    boxSizing: 'border-box',
    boxShadow: `0px 0px ${pxToRem(10)} #0000001F`,
    // marginTop: { xs: pxToRem(20), md: pxTovW(18) },
    paddingLeft: { md: pxTovW(20) },
    paddingRight: { md: pxTovW(20) },
    paddingTop: { xs: pxToRem(10), md: pxTovW(39) },
    paddingBottom: { md: pxTovW(39) },
    marginLeft: { lg: pxTovW(95) },
  },
  grid: {
    width: '100%',
    // backgroundColor: 'red',
    boxSizing: 'border-box',
    display: 'grid',
    gridTemplateColumns: { xs: 'auto', md: 'auto auto  ' },

    '& > div': {
      paddingBottom: '13px',
      paddingTop: '13px',
      borderBottom: '1px solid #E0DFDE',
    },
    '&  >  :nth-last-of-type(-n+2) ': {
      borderBottom: { md: 'none' },
    },
    '&  >  :nth-last-of-type(-n+1) ': {
      borderBottom: 'none',
    },
  },
  cardBox: {
    // backgroundColor: 'blue',

    // padding: { xs: pxToRem(10), md: pxTovW(0) },
    width: { md: '100%', lg: pxTovW(339) },
    boxSizing: 'border-box',
    paddingTop: { md: pxTovW(20) },
    paddingLeft: { xs: pxToRem(20), md: pxTovW(0) },
    paddingRight: { xs: pxToRem(20), md: pxTovW(0) },
    // paddingBottom: { md: pxTovW(10) },
    // marginRight: { md: pxTovW(70) },
    cursor: 'pointer',
  },
};

export const PerformanceDashboard = () => {
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isIpadOnly } = useGlobalContext();
  const [modalState, setModalState] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);
  const { overall_stats, performance_id } = deserify(
    useAppSelector((state) => state.performance)
  );
  const { userInfo, session_mode } = deserify(
    useAppSelector((state) => state.auth)
  );
  const learnSubjects =
    deserify(useAppSelector((state) => state.auth.userInfo?.learnSubjects)) ||
    [];
  const { selected_subject_id } = deserify(
    useAppSelector((state) => state.home)
  );

  const {
    StudentAnalysisAPIServiceV2ClientWithStatusCodeHandler,
    AiStudentAPIServiceV1ClientWithStatusCodeHandler,
    LmsCommonAPIServiceV1ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const subMap = getSubjectsMap(learnSubjects);
  const { isOffline } = useDownloadContext();
  const { setSelectedFunction } = useGlobalContext();

  // Suggested Learning state
  const [suggestedResources, setSuggestedResources] = useState<ResourceInfo[]>(
    []
  );
  const [suggestedLoading, setSuggestedLoading] = useState(false);
  const [recommendationId, setRecommendationId] = useState<string | undefined>(
    undefined
  );
  const [lockedData, setLockedData] = useState<ResourceLock[]>();
  const isContentLockFeature = useFeatureEnabled(
    userInfo?.schoolDetails?.featuresPlanInfo,
    Feature.CONTENT_LOCK
  );

  // --------------------------------------------------------------

  const backButtonClick = async () => {
    await aiPerformanceCloseEvent({
      performanceId: performance_id,
      isOffline: isOffline,
    });
    dispatch(setPerformanceId(undefined));
    navigate(HOME);
  };

  useEffect(() => {
    fetchStudentOverallPerformance();
    fetchSuggestedRecommendations();
    setSelectedFunction(() => backButtonClick);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  // --------------------------------------------------------------

  async function fetchStudentOverallPerformance() {
    try {
      setLoading(true);
      const response =
        await StudentAnalysisAPIServiceV2ClientWithStatusCodeHandler.fetchOverAllAnalysisStats(
          {
            studentId: userInfo?.studentProfileId,
          }
        );
      // console.log(response.data);
      setLoading(false);
      if (response.data) {
        dispatch(setOverallAnalysis(response.data));

        let performanceId;
        if (!performance_id) {
          performanceId = uuidv4();
          dispatch(setPerformanceId(performanceId));
        } else {
          performanceId = performance_id;
        }
        await aiPerformanceOpenEvent({
          performanceId: performanceId,
          isOffline: isOffline,
        });
        return;
      }
      dispatch(setOverallAnalysis(undefined));
    } catch (err) {
      setLoading(false);
      setError(true);
      console.log(err);
    }
  }

  // --------------------------------------------------------------

  async function fetchSuggestedRecommendations() {
    try {
      if (!userInfo?.studentProfileId) {
        return;
      }
      setSuggestedLoading(true);
      const response =
        await AiStudentAPIServiceV1ClientWithStatusCodeHandler.getStudentResourceRecommendationfromGeneoAi(
          {
            studentId: userInfo?.studentProfileId,
            sendFrom: RecommendationReqSendFromTypeEnum.PERFOMANCE_HOMEPAGE,
          }
        );
      if (response) {
        setSuggestedLoading(false);
        if (response.data) {
          setSuggestedResources(response.data?.resources || []);
          const resourceIds = response?.data?.resources?.map(
            (resource) => resource.resourceId
          );
          if (
            isContentLockFeature &&
            userInfo?.studentProfileId &&
            resourceIds.length > 0
          ) {
            await fetchLockContent(resourceIds);
          }
          setRecommendationId(response.data.recommendationId);
          return;
        }
      }
      setSuggestedResources([]);
    } catch (err) {
      setSuggestedLoading(false);
      console.log(err);
      setSuggestedResources([]);
    }
  }

  // --------------------------------------------------------------

  async function fetchLockContent(resourceIds: string[]) {
    try {
      const response =
        await LmsCommonAPIServiceV1ClientWithStatusCodeHandler.getLockStatusByIds(
          {
            personId: userInfo?.studentProfileId,
            personType: ProfileRolesEnum.PROFILE_ROLE_STUDENT,
            subjectId: selected_subject_id,
            schoolClassSectionId: userInfo?.classSectionDetails?.sectionId,
            resourceIds: resourceIds,
          }
        );
      if (response) {
        setLockedData(response?.resourceInfo);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const filteredLearnSubjects = useFilteredLearnSubjects();

  // --------------------------------------------------------------

  return loading === true ? (
    <Shimmer />
  ) : (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Typography variant={largeScreen ? 'g1' : 'h1'}>Performance</Typography>
      </Box>
      {error === true ? (
        <NoContentCard variant="error" icon="error" text="Error Occured" />
      ) : overall_stats ? (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: pxToRem(20), md: pxTovW(40) },
            justifyContent: { xs: 'center', md: 'normal' },
            alignItems: { xs: 'center', md: 'normal' },

            marginBottom: { md: pxTovW(120), lg: pxTovW(80) },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(20), md: pxTovW(20) },
              justifyContent: { xs: 'center', md: 'normal' },
              alignItems: { xs: 'center', md: 'normal' },
              width: { xs: '100%', md: '45%', lg: '35%' },
              position: 'relative',
              // zIndex: 1000,
              // backgroundColor: 'red',
            }}
          >
            {largeScreen ? (
              <Button
                sx={styles.dropDownButton}
                onClick={async () => {
                  setModalState(true);
                  await interactionEvent({
                    url: 'Student_performance_dash',
                    context: 'navigation_bar',
                    name: 'subject_selection',
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }}
              >
                <Typography
                  variant={isIpadOnly ? 'h4' : 'h5'}
                  fontWeight="medium"
                >
                  All Subjects
                </Typography>
                <Box>
                  <ArrowForwardIosIcon
                    sx={{
                      height: { xs: pxToRem(12.55), lg: pxTovW(15) },
                      width: { xs: pxToRem(7.18), lg: pxTovW(15) },
                      color: '#828282',
                    }}
                  />
                </Box>
              </Button>
            ) : (
              <SecondaryButton
                styles={{ height: { xs: pxToRem(45) }, width: '90%' }}
                witharrow
                onClick={async () => {
                  setModalState(true);
                  await interactionEvent({
                    url: 'Student_performance_dash',
                    context: 'navigation_bar',
                    name: 'subject_selection',
                    pathSegments: pathSegments,
                    isOffline: isOffline,
                  });
                }}
              >
                <Typography>All Subjects</Typography>
              </SecondaryButton>
            )}
            <Box sx={styles.iconCard}>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}
              >
                <Box sx={styles.iconBox}>
                  <Box sx={styles.iconInfo}>
                    <IconWrapper
                      name="percentage"
                      size={isIpadOnly ? 'large' : 'md'}
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {Math.round(overall_stats?.scorePercent)}
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    fontWeight="regular"
                    sx={{ color: '#828282' }}
                  >
                    Score
                  </Typography>
                </Box>

                <Box sx={styles.iconBox}>
                  <Box sx={styles.iconInfo}>
                    <IconWrapper
                      name="reading"
                      size={isIpadOnly ? 'large' : 'md'}
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {(overall_stats?.submittedHwCount || 0) +
                        (overall_stats?.submittedFaCount || 0)}
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    fontWeight="regular"
                    sx={{ color: '#828282' }}
                  >
                    Assessment
                  </Typography>
                </Box>
                <Box sx={styles.iconBox}>
                  <Box sx={styles.iconInfo}>
                    <IconWrapper
                      name="clock"
                      size={isIpadOnly ? 'large' : 'md'}
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {Math.round(Number(overall_stats?.timeSpentInMin))}
                    </Typography>
                    <Typography
                      variant="button"
                      color="#828282"
                      fontWeight="regular"
                    >
                      min
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    fontWeight="regular"
                    sx={{ color: '#828282' }}
                  >
                    Time
                  </Typography>
                </Box>
              </Box>
            </Box>

            {largeScreen &&
            currentSessionMode({ reduxSessionMode: session_mode }) !==
              'assess' ? (
              <SuggestedLearning
                resources={suggestedResources}
                loading={suggestedLoading}
                recommendationId={recommendationId}
                lockedData={lockedData}
              />
            ) : null}
          </Box>
          <Box sx={{ width: isIpadOnly ? '55%' : 'unset' }}>
            {overall_stats.subjectsPerformance.length !== 0 ? (
              <Box sx={styles.chapterScoreCard}>
                <Box container component={Grid} sx={styles.grid}>
                  {overall_stats?.subjectsPerformance.map(
                    (elem: SubjectPerformanceOverAllStats, i) => (
                      <Box
                        key={i}
                        sx={styles.cardBox}
                        onClick={async () => {
                          dispatch(setPerformanceSubjectId(elem.subjectId));
                          navigate(PERFORMANCE_STUDENT_CHAPTERWISE);
                          await interactionEvent({
                            url: '',
                            context: 'popup',
                            name: 'CHAPTER_SCORE_POPUP_CLOSE',
                            pathSegments: pathSegments,
                            isOffline: isOffline,
                          });
                        }}
                      >
                        <ClassScoreCard
                          iconName={subMap[elem.subjectId]?.subjectName}
                          path={getMediaBasePath(
                            subMap[elem.subjectId]?.iconUrl,
                            'schoolnetStaticAssetBucket'
                          )}
                          className={subMap[elem.subjectId]?.subjectName}
                          score={Math.round(elem.scorePercent)}
                        />
                      </Box>
                    )
                  )}
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  marginLeft: { md: pxTovW(95) },
                  width: { xs: '100vw', md: pxTovW(794) },
                  // backgroundColor: 'red',
                }}
              >
                <NoContentCard
                  variant="info"
                  icon="cards"
                  text="No data available"
                />
              </Box>
            )}
          </Box>

          {!largeScreen &&
          currentSessionMode({ reduxSessionMode: session_mode }) !==
            'assess' ? (
            <SuggestedLearning
              resources={suggestedResources}
              loading={suggestedLoading}
              recommendationId={recommendationId}
              lockedData={lockedData}
            />
          ) : null}
        </Box>
      ) : (
        <Box
          sx={{
            marginLeft: { md: pxTovW(95) },
            width: { xs: '100vw', md: pxTovW(794) },
            // backgroundColor: 'red',
          }}
        >
          <NoContentCard variant="info" icon="cards" text="No data available" />
        </Box>
      )}
      <StudentSubjectPopup
        modalState={modalState}
        setModalState={setModalState}
        displayData={filteredLearnSubjects.map((sub) => ({
          subject: sub.subjectName,
          icon: getMediaBasePath(sub.iconUrl, 'schoolnetStaticAssetBucket'),
          color: sub.textColor,
          onClick: async () => {
            dispatch(setPerformanceSubjectId(sub.subjectId));
            setModalState(false);
            await interactionEvent({
              url: 'Student_performance_dash',
              context: 'choose_subject',
              name: sub.subjectName.toUpperCase().replace(/ /g, '_'),
              pathSegments: pathSegments,
              isOffline: isOffline,
            });
            navigate(PERFORMANCE_STUDENT_CHAPTERWISE);
          },
        }))}
        title="Choose Subject"
      />
    </Box>
  );
};

const displayData = [
  {
    iconName: 'science',
    className: 'Science',
    score: 10,
  },
  {
    iconName: 'maths',
    className: 'Maths',
    score: 50,
  },
  {
    iconName: 'english',
    className: 'English',
    score: 30,
  },
  {
    iconName: 'vocab-victory',
    className: 'Vocab-Victory',
    score: 60,
  },
  {
    iconName: 'marathi',
    className: 'Marathi',
    score: 45,
  },
  {
    iconName: 'social-science',
    className: 'Social Science',
    score: 85,
  },
];
const subjectsWithClass = [
  { subject: 'English', icon: 'english', class: '1A' },
  { subject: 'English', icon: 'english', class: '2C' },
  { subject: 'Maths', icon: 'maths', class: '3A' },
  { subject: 'Maths', icon: 'maths', class: '3B' },
  { subject: 'Marathi', icon: 'marathi', class: '3C' },
  { subject: 'Marathi', icon: 'marathi', class: '3D' },
  { subject: 'Science', icon: 'science', class: '8A' },
  { subject: 'Science', icon: 'science', class: '8B' },
];
